var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"/api/v2/toolsdoc/index.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }